// extracted by mini-css-extract-plugin
module.exports = {"container":"simple-dropdown_container__3iIwA","text":"simple-dropdown_text__1ccya","icon":"simple-dropdown_icon__1BVI1"};